import React from "react";
import {
  Modal,
  Button,
  ButtonGroup,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Table,
} from "reactstrap";
import { ClipLoader } from "react-spinners";

import api from "../../../Api.js";

function mergeParticipantsWithCompanyUsers(participants, companyUsers) {
  const participantMap = new Map();
  participants.forEach((participant) => {
    if (participant && participant.id != null) {
      participantMap.set(participant.id, participant);
    }
  });

  const merged = [];

  companyUsers.forEach((user) => {
    if (!user || user.id == null) return;
    if (participantMap.has(user.id)) {
      merged.push(participantMap.get(user.id));
      participantMap.delete(user.id);
    } else {
      merged.push({
        id: user.id,
        name: user.name,
        lastName: user.lastName,
        user: user.user,
        email: user.email,
        photo: user.photo,
      });
    }
  });

  participantMap.forEach((participant) => merged.push(participant));
  return merged;
}

export default class ParticipantsManageModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputSearchUser: "",
      searchUser: [],
      loadingSearchUsers: false,
      listAllModal: false,
      modalAllUsers: [],
      selectedUsers: [],
      selectedParticipants: [],
      bulkAddRole: "",
      bulkAddProgress: false,
      bulkRemoveProgress: false,
      activeUsersTab: "participantes",
      searchTimeout: null,
    };

    this.toggleListAllModal = this.toggleListAllModal.bind(this);
    this.searchUserClassRoomAll = this.searchUserClassRoomAll.bind(this);
    this.searchUserClassRoom = this.searchUserClassRoom.bind(this);
    this.searchUserClassRoomTerm = this.searchUserClassRoomTerm.bind(this);
    this.isUserSelected = this.isUserSelected.bind(this);
    this.toggleUserSelection = this.toggleUserSelection.bind(this);
    this.bulkAddUsers = this.bulkAddUsers.bind(this);
    this.toggleParticipantSelection = this.toggleParticipantSelection.bind(this);
    this.isParticipantSelected = this.isParticipantSelected.bind(this);
    this.selectAllCurrentParticipants = this.selectAllCurrentParticipants.bind(this);
    this.clearSelectedParticipants = this.clearSelectedParticipants.bind(this);
    this.bulkRemoveParticipants = this.bulkRemoveParticipants.bind(this);
    this.loadOnlyParticipants = this.loadOnlyParticipants.bind(this);
    this.addUserClassRoomApi = this.addUserClassRoomApi.bind(this);
    this.removeUserClassRoomApi = this.removeUserClassRoomApi.bind(this);
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const currentClassroomId = this.getClassroomId();
    const previousClassroomId = prevProps.classroom?.id;

    if (this.props.isOpen && !prevProps.isOpen) {
      this.bootstrapModal();
    }

    if (
      this.props.isOpen &&
      prevProps.isOpen &&
      currentClassroomId &&
      currentClassroomId !== previousClassroomId
    ) {
      this.bootstrapModal();
    }

    if (!this.props.isOpen && prevProps.isOpen) {
      this.resetState();
    }
  }

  componentDidMount() {
    if (this.props.isOpen) {
      this.bootstrapModal();
    }
  }

  componentWillUnmount() {
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
  }

  getClassroomId() {
    return this.props.classroom?.id;
  }

  resetState() {
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }

    this.setState({
      inputSearchUser: "",
      searchUser: [],
      loadingSearchUsers: false,
      listAllModal: false,
      modalAllUsers: [],
      selectedUsers: [],
      selectedParticipants: [],
      bulkAddRole: "",
      bulkAddProgress: false,
      bulkRemoveProgress: false,
      activeUsersTab: "participantes",
      searchTimeout: null,
    });
  }

  async bootstrapModal() {
    const classroomId = this.getClassroomId();
    if (!classroomId) {
      return;
    }

    this.setState({
      inputSearchUser: "",
      listAllModal: false,
      modalAllUsers: [],
      selectedUsers: [],
      selectedParticipants: [],
      bulkAddRole: "",
      activeUsersTab: "participantes",
      loadingSearchUsers: true,
    });

    try {
      const participantsPromise = api.searchUserClassRoom(classroomId, "");
      const companyId = this.props.companyId;
      const companyPromise = companyId
        ? api.getUsersCompany(companyId)
        : Promise.resolve({ data: [] });

      const [participantsRes, companyRes] = await Promise.all([
        participantsPromise,
        companyPromise,
      ]);

      const participants = Array.isArray(participantsRes?.data)
        ? participantsRes.data
        : [];
      const companyUsers = Array.isArray(companyRes?.data)
        ? companyRes.data
        : [];

      const merged = mergeParticipantsWithCompanyUsers(participants, companyUsers);

      this.setState({
        searchUser: merged,
        loadingSearchUsers: false,
      });
    } catch (error) {
      console.error("Erro ao carregar participantes da turma:", error);
      this.setState({ loadingSearchUsers: false });
    }
  }

  notify(options) {
    if (typeof this.props.notify === "function") {
      this.props.notify(options);
    }
  }

  async toggleListAllModal() {
    if (!this.state.listAllModal) {
      // Entrando no modo global
      this.setState({ loadingSearchUsers: true });
      try {
        // Usa a API existente com um termo vazio para buscar todos
        const classroomId = this.getClassroomId();
        const response = await api.searchUserClassRoomTerm(classroomId, "");

        if (!response || !response.data) {
          throw new Error("Resposta inválida da API");
        }

        const allUsers = response.data;

        this.setState({
          modalAllUsers: allUsers,
          searchUser: allUsers,
          listAllModal: true,
          loadingSearchUsers: false,
        });
      } catch (err) {
        console.error("Erro ao carregar usuários no modo global:", err);
        this.setState({ loadingSearchUsers: false });
        this.notify({
          place: "tr",
          message: (
            <div className="alert-text">
              <span className="alert-title" data-notify="title">
                Erro!
              </span>
              <span data-notify="message">
                Não foi possível carregar a lista de usuários.
              </span>
            </div>
          ),
          type: "danger",
          icon: "fas fa-exclamation",
          autoDismiss: 7,
        });
      }
    } else {
      // Voltando para o modo unidade
      this.setState(
        {
          listAllModal: false,
          loadingSearchUsers: true,
        },
        async () => {
          // Carrega apenas usuários da unidade atual
          await this.searchUserClassRoomAll();
        }
      );
    }
  }

  async searchUserClassRoomAll() {
    const classroomId = this.getClassroomId();
    if (!classroomId) return;

    this.setState({ loadingSearchUsers: true });

    try {
      if (this.state.listAllModal) {
        const res = await api.searchUserClassRoomTerm(classroomId, "");
        this.setState({
          searchUser: Array.isArray(res?.data) ? res.data : [],
          loadingSearchUsers: false,
        });
        return;
      }

      const participantsRes = await api.searchUserClassRoom(classroomId, "");
      const participants = Array.isArray(participantsRes?.data)
        ? participantsRes.data
        : [];
      const companyId = this.props.companyId;
      const companyRes = companyId
        ? await api.getUsersCompany(companyId)
        : { data: [] };
      const companyUsers = Array.isArray(companyRes?.data)
        ? companyRes.data
        : [];

      const merged = mergeParticipantsWithCompanyUsers(participants, companyUsers);
      this.setState({ searchUser: merged, loadingSearchUsers: false });
    } catch (error) {
      console.error("Erro ao carregar todos os usuários:", error);
      this.setState({ loadingSearchUsers: false });
    }
  }

  async searchUserClassRoom() {
    const term = (this.state.inputSearchUser || "").trim();
    if (!term) {
      return this.searchUserClassRoomAll();
    }

    if (this.state.listAllModal) {
      const lower = term.toLowerCase();

      if (lower.length < 3) {
        const filtered = (this.state.modalAllUsers || []).filter((user) => {
          const fullName = `${user.name || ""} ${user.lastName || ""}`
            .toLowerCase()
            .trim();
          return (
            fullName.includes(lower) ||
            (user.email || "").toLowerCase().includes(lower) ||
            (user.user || "").toLowerCase().includes(lower)
          );
        });

        this.setState({ searchUser: filtered, loadingSearchUsers: false });
        return;
      }

      this.setState({ loadingSearchUsers: true });
      try {
        const response = await api.searchUserClassRoomTerm(
          this.getClassroomId(),
          lower
        );
        this.setState({
          searchUser: Array.isArray(response?.data) ? response.data : [],
          loadingSearchUsers: false,
        });
      } catch (error) {
        console.error("Erro na busca global:", error);
        this.setState({ loadingSearchUsers: false });

        const fallback = (this.state.modalAllUsers || []).filter((user) => {
          const fullName = `${user.name || ""} ${user.lastName || ""}`
            .toLowerCase()
            .trim();
          return (
            fullName.includes(lower) ||
            (user.email || "").toLowerCase().includes(lower) ||
            (user.user || "").toLowerCase().includes(lower)
          );
        });

        this.setState({ searchUser: fallback });
      }
      return;
    }

    return this.searchUserClassRoomTerm();
  }

  async searchUserClassRoomTerm() {
    const classroomId = this.getClassroomId();
    const companyId = this.props.companyId;
    if (!classroomId) {
      return;
    }

    this.setState({ loadingSearchUsers: true });

    try {
      const lower = (this.state.inputSearchUser || "").trim().toLowerCase();

      if (this.state.listAllModal) {
        const response = await api.searchUserClassRoomTerm(classroomId, lower);
        this.setState({
          searchUser: Array.isArray(response?.data) ? response.data : [],
          loadingSearchUsers: false,
        });
        return;
      }

      const companyRes = companyId
        ? await api.getUsersCompany(companyId)
        : { data: [] };
      const allUsers = Array.isArray(companyRes?.data) ? companyRes.data : [];

      const participantsRes = await api.searchUserClassRoom(classroomId, "");
      const usersInClassroom = Array.isArray(participantsRes?.data)
        ? participantsRes.data
        : [];
      const inClassMap = {};

      usersInClassroom.forEach((u) => {
        if (u && u.id != null) {
          inClassMap[u.id] = u.inclassroom;
        }
      });

      const filteredCompany = allUsers.filter((u) => {
        const fullName = `${u.name || ""} ${u.lastName || ""}`
          .toLowerCase()
          .trim();
        return (
          fullName.includes(lower) ||
          (u.email || "").toLowerCase().includes(lower) ||
          (u.user || "").toLowerCase().includes(lower)
        );
      });

      const merged = filteredCompany.map((u) => ({
        id: u.id,
        name: u.name,
        lastName: u.lastName,
        user: u.user,
        email: u.email,
        photo: u.photo,
        inclassroom: inClassMap[u.id] || undefined,
      }));

      this.setState({ searchUser: merged, loadingSearchUsers: false });
    } catch (error) {
      console.error("Erro na busca por termo:", error);
      this.setState({ loadingSearchUsers: false });
    }
  }

  async loadOnlyParticipants() {
    const classroomId = this.getClassroomId();
    if (!classroomId) return;

    this.setState({ loadingSearchUsers: true });
    try {
      const res = await api.searchUserClassRoom(classroomId, "");
      const participants = Array.isArray(res?.data) ? res.data : [];
      const mapped = participants.map((u) => ({
        id: u.id,
        name: u.name,
        lastName: u.lastName,
        user: u.user,
        email: u.email,
        photo: u.photo,
        inclassroom: u.inclassroom,
      }));

      this.setState({ searchUser: mapped, loadingSearchUsers: false });
    } catch (error) {
      console.error("Erro ao carregar participantes:", error);
      this.setState({ loadingSearchUsers: false });
    }
  }

  isUserSelected(userId) {
    return this.state.selectedUsers.some((user) => user.id === userId);
  }

  toggleUserSelection(user) {
    this.setState((prev) => {
      const selected = [...prev.selectedUsers];
      const index = selected.findIndex((u) => u.id === user.id);
      if (index === -1) {
        selected.push(user);
      } else {
        selected.splice(index, 1);
      }
      return { selectedUsers: selected };
    });
  }

  async bulkAddUsers() {
    const { selectedUsers, bulkAddRole } = this.state;
    const classroomId = this.getClassroomId();

    if (!bulkAddRole) {
      this.notify({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">
              {(this.props.translate?.atencao || "Atenção") + "!"}
            </span>
            <span data-notify="message">
              {this.props.translate?.selecione_um_papel_para_os_usuarios ||
                "Selecione um papel para os usuários."}
            </span>
          </div>
        ),
        type: "warning",
        icon: "fas fa-exclamation",
        autoDismiss: 7,
      });
      return;
    }

    if (!selectedUsers.length || !classroomId) {
      this.notify({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">
              {(this.props.translate?.atencao || "Atenção") + "!"}
            </span>
            <span data-notify="message">
              {this.props.translate?.nenhum_usuario_selecionado ||
                "Nenhum usuário selecionado."}
            </span>
          </div>
        ),
        type: "warning",
        icon: "fas fa-exclamation",
        autoDismiss: 7,
      });
      return;
    }

    this.setState({ bulkAddProgress: true });

    try {
      const results = await Promise.all(
        selectedUsers.map((user) =>
          api
            .addUserClassRoom({
              user: user.id,
              classroom: classroomId,
              type: bulkAddRole,
            })
            .catch((error) => ({ error: true, user, details: error }))
        )
      );

      const failures = results.filter((result) => result && result.error);
      const successCount = selectedUsers.length - failures.length;

      this.notify({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">
              {(this.props.translate?.adicao_em_massa_concluida ||
                "Adição em massa concluída") + "!"}
            </span>
            <span data-notify="message">
              {`${successCount} ${(this.props.translate?.usuarios_adicionados || "usuário(s) adicionado(s) com sucesso")}${failures.length ? ` ${failures.length} ${this.props.translate?.falhas || "falha(s)"}.` : ""}`}
            </span>
          </div>
        ),
        type: successCount > 0 ? "success" : "warning",
        icon: successCount > 0 ? "ni ni-check-bold" : "fas fa-exclamation",
        autoDismiss: 7,
      });

      this.setState({
        selectedUsers: [],
        bulkAddRole: "",
        bulkAddProgress: false,
      });

      if (typeof this.props.onParticipantsChanged === "function") {
        try {
          await this.props.onParticipantsChanged();
        } catch (err) {
          console.error("onParticipantsChanged handler failed:", err);
        }
      }

      await this.searchUserClassRoom();
    } catch (error) {
      console.error("Erro na adição em massa:", error);
      this.setState({ bulkAddProgress: false });
      this.notify({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">
              {(this.props.translate?.erro || "Erro") + "!"}
            </span>
            <span data-notify="message">
              {this.props.translate?.nao_foi_possivel_processar_adicao_em_massa ||
                "Não foi possível concluir a adição em massa."}
            </span>
          </div>
        ),
        type: "danger",
        icon: "fas fa-exclamation",
        autoDismiss: 7,
      });
    }
  }

  toggleParticipantSelection(user) {
    this.setState((prev) => {
      const selected = [...prev.selectedParticipants];
      const index = selected.findIndex((u) => u.id === user.id);
      if (index === -1) {
        selected.push(user);
      } else {
        selected.splice(index, 1);
      }
      return { selectedParticipants: selected };
    });
  }

  isParticipantSelected(userId) {
    return this.state.selectedParticipants.some((user) => user.id === userId);
  }

  selectAllCurrentParticipants() {
    const participants = (this.state.searchUser || []).filter(
      (user) => user.inclassroom !== undefined
    );
    this.setState({ selectedParticipants: participants });
  }

  clearSelectedParticipants() {
    this.setState({ selectedParticipants: [] });
  }

  async bulkRemoveParticipants() {
    const { selectedParticipants } = this.state;
    const classroomId = this.getClassroomId();

    if (!selectedParticipants.length || !classroomId) {
      return;
    }

    this.setState({ bulkRemoveProgress: true });

    try {
      const results = await Promise.all(
        selectedParticipants.map((user) =>
          api
            .deleteUserClassRoomApi(classroomId, user.id)
            .catch((error) => ({ error: true, user, details: error }))
        )
      );

      const failures = results.filter((result) => result && result.error);
      const successCount = selectedParticipants.length - failures.length;

      this.notify({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">
              {(this.props.translate?.remocao_em_massa_concluida ||
                "Remoção em massa concluída") + "!"}
            </span>
            <span data-notify="message">
              {`${successCount} ${(this.props.translate?.usuarios_removidos || "usuário(s) removido(s).")}${failures.length ? ` ${failures.length} ${this.props.translate?.falhas || "falha(s)"}.` : ""}`}
            </span>
          </div>
        ),
        type: successCount > 0 ? "success" : "warning",
        icon: successCount > 0 ? "ni ni-check-bold" : "fas fa-exclamation",
        autoDismiss: 7,
      });

      this.setState({
        selectedParticipants: [],
        bulkRemoveProgress: false,
      });

      if (typeof this.props.onParticipantsChanged === "function") {
        try {
          await this.props.onParticipantsChanged();
        } catch (err) {
          console.error("onParticipantsChanged handler failed:", err);
        }
      }

      await this.loadOnlyParticipants();
    } catch (error) {
      console.error("Erro na remoção em massa:", error);
      this.setState({ bulkRemoveProgress: false });
      this.notify({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">
              {(this.props.translate?.erro || "Erro") + "!"}
            </span>
            <span data-notify="message">
              {this.props.translate?.nao_foi_possivel_remover_usuarios ||
                "Não foi possível concluir a remoção em massa."}
            </span>
          </div>
        ),
        type: "danger",
        icon: "fas fa-exclamation",
        autoDismiss: 7,
      });
    }
  }

  async addUserClassRoomApi(userId, type) {
    const classroomId = this.getClassroomId();
    if (!classroomId || !userId || !type) {
      return;
    }

    try {
      await api.addUserClassRoom({
        user: userId,
        classroom: classroomId,
        type,
      });

      this.notify({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">
              {(this.props.translate?.sucesso || "Sucesso") + "!"}
            </span>
            <span data-notify="message">
              {this.props.translate?.usuario_cadastrado_na_turma ||
                "O usuário foi cadastrado na turma."}
            </span>
          </div>
        ),
        type: "success",
        icon: "ni ni-check-bold",
        autoDismiss: 7,
      });

      if (typeof this.props.onParticipantsChanged === "function") {
        try {
          await this.props.onParticipantsChanged();
        } catch (err) {
          console.error("onParticipantsChanged handler failed:", err);
        }
      }

      await this.searchUserClassRoom();
    } catch (error) {
      console.error("Erro ao adicionar usuário à turma:", error);
      const message =
        error?.response?.data?.msg ||
        this.props.translate?.nao_foi_possivel_adicionar_usuario ||
        "Não foi possível adicionar o usuário.";

      this.notify({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">
              {(this.props.translate?.erro || "Erro") + "!"}
            </span>
            <span data-notify="message">{message}</span>
          </div>
        ),
        type: "danger",
        icon: "fas fa-exclamation",
        autoDismiss: 7,
      });
    }
  }

  async removeUserClassRoomApi(userId) {
    const classroomId = this.getClassroomId();
    if (!classroomId || !userId) {
      return;
    }

    try {
      await api.deleteUserClassRoomApi(classroomId, userId);

      this.notify({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">
              {(this.props.translate?.sucesso || "Sucesso") + "!"}
            </span>
            <span data-notify="message">
              {this.props.translate?.usuario_removido_da_turma ||
                "O usuário foi removido da turma."}
            </span>
          </div>
        ),
        type: "success",
        icon: "ni ni-check-bold",
        autoDismiss: 7,
      });

      if (typeof this.props.onParticipantsChanged === "function") {
        try {
          await this.props.onParticipantsChanged();
        } catch (err) {
          console.error("onParticipantsChanged handler failed:", err);
        }
      }

      await this.searchUserClassRoom();
    } catch (error) {
      console.error("Erro ao remover usuário da turma:", error);
      const message =
        error?.response?.data?.msg ||
        this.props.translate?.nao_foi_possivel_remover_usuario ||
        "Não foi possível remover o usuário.";

      this.notify({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">
              {(this.props.translate?.erro || "Erro") + "!"}
            </span>
            <span data-notify="message">{message}</span>
          </div>
        ),
        type: "danger",
        icon: "fas fa-exclamation",
        autoDismiss: 7,
      });
    }
  }

  handleSearchInputChange(event) {
    const term = event.target.value;
    const { searchTimeout } = this.state;

    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    const timeout = setTimeout(() => {
      this.searchUserClassRoom();
    }, 500);

    this.setState({ inputSearchUser: term, searchTimeout: timeout });
  }

  closeModal() {
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
  }

  render() {
    const t = this.props.translate || {};
    const permissionsCatalog =
      this.props.permissionsCatalog || window.app?.state?.permitions || [];
    const {
      searchUser,
      loadingSearchUsers,
      selectedUsers,
      selectedParticipants,
      bulkAddRole,
      bulkAddProgress,
      bulkRemoveProgress,
      inputSearchUser,
      listAllModal,
      activeUsersTab,
    } = this.state;

    const canManage =
      Array.isArray(this.props.permission) &&
      this.props.permission.includes(17);
    const activeTab = canManage ? activeUsersTab : "participantes";

    const currentParticipants = (searchUser || []).filter(
      (user) => user.inclassroom !== undefined
    );
    const availableUsers = (searchUser || []).filter(
      (user) => user.inclassroom === undefined
    );

    return (
      <Modal
        className="modal-dialog-centered modal-lg"
        isOpen={Boolean(this.props.isOpen)}
        toggle={this.closeModal}
      >
        <div className="modal-header bg-secondary">
          <h5 className="modal-title">
            {t["gerenciar_participantes_da_turma"] ||
              "Gerenciar Participantes da Turma"}
          </h5>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={this.closeModal}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body bg-secondary p-0">
          <ul className="nav nav-tabs nav-fill" role="tablist">
                <li className="nav-item">
              <a
                className={`nav-link mb-sm-3 mb-md-0 ${
                  activeTab === "participantes" ? "active" : ""
                }`}
                id="participantes-tab"
                href="#!"
                role="tab"
                aria-controls="participantes"
                aria-selected={activeTab === "participantes"}
                onClick={(event) => {
                  event.preventDefault();
                  this.setState({ activeUsersTab: "participantes", listAllModal: false }, () => {
                    this.loadOnlyParticipants();
                  });
                }}
              >
                <i className="fas fa-users mr-2"></i>
                {t["participantes_da_turma"] || "Participantes da Turma"}
              </a>
            </li>
            {canManage && (
              <>
                <li className="nav-item">
                  <a
                    className={`nav-link mb-sm-3 mb-md-0 ${
                      activeTab === "adicionar" ? "active" : ""
                    }`}
                    id="adicionar-tab"
                    href="#!"
                    role="tab"
                    aria-controls="adicionar"
                    aria-selected={activeTab === "adicionar"}
                    onClick={(event) => {
                      event.preventDefault();
                      this.setState({ activeUsersTab: "adicionar" });
                    }}
                  >
                    <i className="fas fa-user-plus mr-2"></i>
                    {t["adicionar_participantes"] || "Adicionar Participantes"}
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link mb-sm-3 mb-md-0 ${
                      activeTab === "massa" ? "active" : ""
                    }`}
                    id="massa-tab"
                    href="#!"
                    role="tab"
                    aria-controls="massa"
                    aria-selected={activeTab === "massa"}
                    onClick={(event) => {
                      event.preventDefault();
                      this.setState({ activeUsersTab: "massa" });
                    }}
                  >
                    <i className="fas fa-users-cog mr-2"></i>
                    {t["adicao_em_massa"] || "Adição em Massa"}
                  </a>
                </li>
              </>
            )}
          </ul>

          <div className="tab-content px-4 py-3">
            <div
              className={`tab-pane fade ${
                activeTab === "participantes" ? "show active" : ""
              }`}
              id="participantes"
              role="tabpanel"
              aria-labelledby="participantes-tab"
            >
              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="mb-0">
                    {t["participantes_atuais_da_turma"] ||
                      "Participantes Atuais da Turma"}
                    {!loadingSearchUsers && (
                      <span className="badge badge-primary ml-2">
                        {currentParticipants.length}
                      </span>
                    )}
                  </h6>
                  <div className="d-flex align-items-center">
                    <Button
                      color="secondary"
                      outline
                      size="sm"
                      className="mr-2"
                      onClick={this.loadOnlyParticipants}
                      disabled={loadingSearchUsers}
                      title={t["atualizar_lista"] || "Atualizar Lista"}
                    >
                      <i className="fas fa-sync-alt"></i>
                    </Button>

                    <ButtonGroup className="mr-2">
                      <Button
                        color="secondary"
                        outline
                        size="sm"
                        onClick={this.selectAllCurrentParticipants}
                        disabled={loadingSearchUsers}
                        title={t["selecionar_todos"] || "Selecionar Todos"}
                      >
                        <i className="fas fa-check-double"></i>
                      </Button>
                      <Button
                        color="secondary"
                        outline
                        size="sm"
                        onClick={this.clearSelectedParticipants}
                        disabled={
                          loadingSearchUsers || selectedParticipants.length === 0
                        }
                        title={t["limpar"] || "Limpar"}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </ButtonGroup>

                    <Button
                      color="danger"
                      size="sm"
                      onClick={this.bulkRemoveParticipants}
                      disabled={
                        bulkRemoveProgress || selectedParticipants.length === 0
                      }
                    >
                      {bulkRemoveProgress ? (
                        <>
                          <ClipLoader
                            size={14}
                            color="#fff"
                            loading={true}
                            className="mr-2"
                          />
                          {t["removendo"] || "Removendo..."}
                        </>
                      ) : (
                        <>
                          <i className="ni ni-fat-remove mr-1"></i>
                          {t["remover"] || "Remover"} ({selectedParticipants.length})
                        </>
                      )}
                    </Button>
                  </div>
                </div>

                <FormGroup className="mb-0">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-zoom-split-in" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder={
                        t["pesquisar_por_nome_email_ou_usuario"] ||
                        "Pesquisar por nome, email ou usuário..."
                      }
                      type="text"
                      value={inputSearchUser}
                      onChange={this.handleSearchInputChange}
                    />
                    <InputGroupAddon addonType="append">
                      {loadingSearchUsers ? (
                        <InputGroupText
                          style={{ background: "transparent", border: "none" }}
                        >
                          <ClipLoader
                            size={18}
                            color="#172b4d"
                            loading={true}
                          />
                        </InputGroupText>
                      ) : inputSearchUser ? (
                        <InputGroupText style={{ cursor: "pointer" }}>
                          <button
                            type="button"
                            className="btn p-0"
                            onClick={() => {
                              if (this.state.searchTimeout)
                                clearTimeout(this.state.searchTimeout);
                              this.setState({ inputSearchUser: "" }, () =>
                                this.searchUserClassRoom()
                              );
                            }}
                          >
                            <i className="fas fa-times text-muted" />
                          </button>
                        </InputGroupText>
                      ) : null}
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
              </div>

              <div
                className="list-group mb-3"
                style={{ maxHeight: "400px", overflowY: "auto" }}
              >
                {!loadingSearchUsers ? (
                  currentParticipants.map((user) => (
                    <div
                      key={`current-${user.id}`}
                      className="list-group-item list-group-item-action d-flex align-items-center justify-content-between"
                    >
                      <div className="d-flex align-items-center">
                        <div className="custom-control custom-checkbox mr-3">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id={`check-part-${user.id}`}
                            checked={this.isParticipantSelected(user.id)}
                            onChange={() => this.toggleParticipantSelection(user)}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor={`check-part-${user.id}`}
                          ></label>
                        </div>
                        <div className="avatar-circle mr-3">
                          <img
                            src={user.photo}
                            alt={user.name}
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                            }}
                          />
                        </div>
                        <div>
                          <h6 className="mb-0">
                            {user.name} {user.lastName}
                          </h6>
                          <small className="text-muted">
                            {user.email || user.user}
                            {user.inclassroom?.type && (
                              <span className="badge badge-primary ml-2">
                                {permissionsCatalog.find(
                                  (perm) => perm.id === user.inclassroom.type
                                )?.name || "Participante"}
                              </span>
                            )}
                          </small>
                        </div>
                      </div>
                      <div>
                        <Button
                          color="danger"
                          size="sm"
                          className="mr-1"
                          onClick={() => this.removeUserClassRoomApi(user.id)}
                        >
                          <i className="ni ni-fat-remove mr-1"></i>
                          {t["remover"] || "Remover"}
                        </Button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-5">
                    <div className="d-flex justify-content-center align-items-center">
                      <ClipLoader size={40} color="#172b4d" loading={true} />
                    </div>
                    <p className="mt-3">
                      {t["pesquisando_usuarios"] || "Pesquisando usuários..."}
                    </p>
                  </div>
                )}

                {!loadingSearchUsers && currentParticipants.length === 0 && (
                  <div className="text-center py-5">
                    <i className="fas fa-users fa-3x mb-3 text-muted"></i>
                    <p>
                      {t["nenhum_participante_encontrado_nesta_turma"] ||
                        "Nenhum participante encontrado nesta turma"}
                    </p>
                  </div>
                )}
              </div>
            </div>

            {canManage && (
              <div
                className={`tab-pane fade ${
                  activeTab === "adicionar" ? "show active" : ""
                }`}
                id="adicionar"
                role="tabpanel"
                aria-labelledby="adicionar-tab"
              >
              <div className="row mb-3">
                <div className="col">
                  <FormGroup className="mb-0">
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-zoom-split-in"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder={
                          t["pesquisar_por_nome_email_ou_usuario"] ||
                          "Pesquisar por nome, email ou usuário..."
                        }
                        type="text"
                        value={inputSearchUser}
                        onChange={this.handleSearchInputChange}
                      />
                    </InputGroup>
                  </FormGroup>
                </div>
                <div className="col-auto">
                  <ButtonGroup>
                    <Button
                      color="primary"
                      size="md"
                      onClick={() => {
                        this.setState(
                          { listAllModal: false, loadingSearchUsers: true },
                          () => this.searchUserClassRoomAll()
                        );
                      }}
                      active={!listAllModal}
                    >
                      <i className="fas fa-building mr-1"></i>
                      {t["listar_unidade"] || "Listar Unidade"}
                    </Button>
                    <Button
                      color="primary"
                      size="md"
                      onClick={this.toggleListAllModal}
                      active={listAllModal}
                    >
                      <i className="fas fa-globe mr-1"></i>
                      {t["listar_todos"] || "Listar Todos"}
                    </Button>
                  </ButtonGroup>
                </div>
              </div>

              <div
                className="list-group"
                style={{ maxHeight: "400px", overflowY: "auto" }}
              >
                {loadingSearchUsers ? (
                  <div className="text-center py-5">
                    <div className="d-flex justify-content-center align-items-center">
                      <ClipLoader size={40} color="#172b4d" loading={true} />
                    </div>
                    <p className="mt-3">
                      {t["pesquisando_usuarios"] || "Pesquisando usuários..."}
                    </p>
                  </div>
                ) : (
                  availableUsers.map((user) => {
                    const isSelected = this.isUserSelected(user.id);
                    return (
                      <div
                        key={`add-${user.id}`}
                        className={`list-group-item ${
                          isSelected ? "list-group-item-light" : ""
                        }`}
                      >
                        <div className="d-flex align-items-center">
                          <div className="custom-control custom-checkbox mr-2">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id={`check-user-${user.id}`}
                              checked={isSelected}
                              onChange={() => this.toggleUserSelection(user)}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={`check-user-${user.id}`}
                            ></label>
                          </div>
                          <div className="avatar-circle mr-3">
                            <img
                              src={user.photo}
                              alt={user.name}
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                              }}
                            />
                          </div>
                          <div className="flex-grow-1">
                            <h6 className="mb-0">
                              {user.name} {user.lastName}
                            </h6>
                            <small className="text-muted">
                              {user.email || user.user}
                            </small>
                          </div>
                          <div className="ml-auto d-flex align-items-center">
                            <select
                              className="form-control form-control-sm mr-2"
                              style={{ width: "150px" }}
                              onChange={(event) => {
                                const value = event.target.value;
                                this.setState((prev) => ({
                                  searchUser: prev.searchUser.map((u) =>
                                    u.id === user.id ? { ...u, type: value } : u
                                  ),
                                }));
                              }}
                              value={user.type || ""}
                            >
                              <option value="">
                                {t["selecione_o_papel"] ||
                                  "Selecione um papel"}
                              </option>
                              {permissionsCatalog.map((perm) => (
                                <option
                                  key={`perm-${user.id}-${perm.id}`}
                                  value={perm.id}
                                >
                                  {perm.name}
                                </option>
                              ))}
                            </select>
                            <Button
                              color="primary"
                              size="sm"
                              disabled={!user.type}
                              onClick={() =>
                                this.addUserClassRoomApi(user.id, user.type)
                              }
                            >
                              <i className="fas fa-plus mr-1"></i>
                              {t["adicionar"] || "Adicionar"}
                            </Button>
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}

                {!loadingSearchUsers && availableUsers.length === 0 && (
                  <div className="text-center py-5">
                    <i className="fas fa-search fa-3x mb-3 text-muted"></i>
                    <p>
                      {t["nenhum_usuario_encontrado_para_adicionar"] ||
                        "Nenhum usuário encontrado para adicionar"}
                    </p>
                    <small className="text-muted">
                      {t["tente_usar_termos_diferentes_na_pesquisa"] ||
                        "Tente usar termos diferentes na pesquisa"}
                    </small>
                  </div>
                )}
              </div>
            </div>
            )}

            {canManage && (
              <div
                className={`tab-pane fade ${
                  activeTab === "massa" ? "show active" : ""
                }`}
                id="massa"
                role="tabpanel"
                aria-labelledby="massa-tab"
              >
              <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6>
                    {t["usuarios_selecionados"] || "Usuários selecionados"} (
                    {selectedUsers.length})
                  </h6>
                  <div>
                    <Button
                      color="info"
                      size="sm"
                      className="mr-2"
                      onClick={() =>
                        this.setState({ selectedUsers: availableUsers })
                      }
                    >
                      <i className="fas fa-check-double mr-1"></i>
                      {t["selecionar_todos"] || "Selecionar Todos"}
                    </Button>
                    <Button
                      color="secondary"
                      size="sm"
                      onClick={() => this.setState({ selectedUsers: [] })}
                    >
                      <i className="fas fa-times mr-1"></i>
                      {t["limpar_selecao"] || "Limpar Seleção"}
                    </Button>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body p-0">
                    {selectedUsers.length > 0 ? (
                      <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                        <Table size="sm" responsive className="table-flush">
                          <thead className="thead-light">
                            <tr>
                              <th>{t["nome"] || "Nome"}</th>
                              <th>{t["email"] || "E-mail"}</th>
                              <th width="40"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedUsers.map((user) => (
                              <tr key={`selected-${user.id}`}>
                                <td>
                                  {user.name} {user.lastName}
                                </td>
                                <td>{user.email}</td>
                                <td>
                                  <Button
                                    color="link"
                                    size="sm"
                                    className="p-0 text-danger"
                                    onClick={() => this.toggleUserSelection(user)}
                                  >
                                    <i className="fas fa-times"></i>
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    ) : (
                      <div className="py-4 text-center">
                        <i className="fas fa-users fa-2x mb-2 text-muted"></i>
                        <p className="mb-0">
                          {t["nenhum_usuario_selecionado"] ||
                            "Nenhum usuário selecionado"}
                        </p>
                        <small className="text-muted">
                          {t["selecione_usuarios_na_aba_adicionar_participantes"] ||
                            'Selecione usuários na aba "Adicionar Participantes"'}
                        </small>
                      </div>
                    )}
                  </div>
                </div>

                <div className="mt-4">
                  <FormGroup>
                    <label className="font-weight-bold">
                      {t["papel_na_turma"] || "Papel na turma"}
                    </label>
                    <Input
                      type="select"
                      value={bulkAddRole}
                      onChange={(event) =>
                        this.setState({ bulkAddRole: event.target.value })
                      }
                      disabled={bulkAddProgress}
                    >
                      <option value="">
                        {t["selecione_um_papel_para_todos"] ||
                          "Selecione um papel para todos"}
                      </option>
                      {permissionsCatalog.map((perm) => (
                        <option key={`bulk-role-${perm.id}`} value={perm.id}>
                          {perm.name}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <div className="text-right">
                    <Button
                      color="success"
                      onClick={this.bulkAddUsers}
                      disabled={
                        bulkAddProgress ||
                        selectedUsers.length === 0 ||
                        !bulkAddRole
                      }
                    >
                      {bulkAddProgress ? (
                        <>
                          <ClipLoader
                            size={15}
                            color="#fff"
                            loading={true}
                            className="mr-2"
                          />
                          {t["adicionando"] || "Adicionando..."}
                        </>
                      ) : (
                        <>
                          <i className="fas fa-user-plus mr-1"></i>
                          {t["adicionar"] || "Adicionar"} {selectedUsers.length}{" "}
                          {t["usuarios"] || "usuário(s)"}
                        </>
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            )}
          </div>
        </div>
        <div className="modal-footer bg-secondary">
          <Button color="default" type="button" onClick={this.closeModal}>
            {t["fechar"] || "Fechar"}
          </Button>
        </div>
      </Modal>
    );
  }
}
